import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
import qs from 'qs';

/**
 * 获取试题库分类列表
 * @param {object} bodyObj 请求参数
 */
export const getCatalogList = q => {
  return apiBaseUrl.get('/ote/lib/catalog/list', q);
};

/**
 * 获取试题库列表
 * @param {object} 请求参数
 */
export const postQuesLibList = (body, params) => {
  return apiBaseUrl.post(`/ote/lib/list?${qs.stringify(body)}`, params);
};

/**
 * 新增试题库基本信息
 * @param {string} bodyObj 请求体
 */
export const createQuesLib = bodyObj => {
  return apiBaseUrl.post('/ote/lib', bodyObj);
};

/**
 * 更新试题库基本信息
 * @param {string} libId 试题库ID
 * @param {object} bodyObj 请求体
 */
export const updateQuesLib = (libId, bodyObj) => {
  return apiBaseUrl.put(`/ote/lib/${libId}`, bodyObj);
};

/**
 * 获取试题库详情
 * @param {string} libId 试题库ID
 */
export const getQuesLibDetail = (libId) => {
  return apiBaseUrl.get(`/ote/lib/${libId}`);
};
